import React, { Component } from 'react';
import { Form, FormGroup, Label } from 'reactstrap';
import { Input } from '@progress/kendo-react-inputs';
import { fetchStates } from '../../../../../../Redux/Actions/CommonActions';
import { DropDownList } from '@progress/kendo-react-dropdowns';
import { getCounties } from '../../../../../../Redux/Actions/Admin/ManageDistrictActions';
import {auth } from '../../../../../../services';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import '../../../../../AdminView/Pages/Administration/ManageMembership/ManageMembership.scss';

class ManualUserForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			email:'',
			userID:'',
			membershipId:0,
			MembershipPackageId:0,
			mailingStateId:0,
			firstName:"",
			lastName:"",
			mailingAddress1:"",
			mailingAddress2:"",
			mailingCity:"",
			mailingZip:"",
			phone:"",
			memberSequenceNum:1,
			stateObject:{
				id:0,
				name:"",
			},
			County:{
				countyId:0,
				countyName:""
			},
			isMembershipOwner:false
		}
	}

	componentDidMount() {
		const membershipId =this.props.accountDetails.selectedMember.membershipId;

		this.setState({
			membershipId: membershipId
		})
	}
	
	onDialogInputChange = (event) => {
		this.setState({
			[event.target.name]: event.target.value
		},() => {
			this.props.manualUserStateChange(this.state);
		});
	};

	handleState = (event) => {
		this.props.getCounties(event.target.value.id);
		this.setState({
			mailingStateId: event.target.value.id,
			stateObject: {
				id: event.target.value.id,
				name: event.target.value.name,
			}
		},() => {
			this.props.manualUserStateChange(this.state);
		});
	};

	handleCounty = (event) => {
		this.setState({
			County: {
				countyId: event.target.value.countyId,
				countyName: event.target.value.countyName,
			}
		},() => {
			this.props.manualUserStateChange(this.state);
		});
	}
	handleCheckboxChange = event => {
		this.setState({ isMembershipOwner: event.target.checked }
		,
		() => {
			this.props.manualUserStateChange(this.state);
		});
		}
		
		handleCancel = (event) => {
			event.preventDefault();
			this.props.cancel();
		}

		checkForm = (event) => {
			this.props.handleSubmit();
		}

	render() {
		return (
            <form className="additionalMembersForm user-form membership-form">
                <div className="row">
			        <FormGroup className="col-md-6">
						        <Label htmlFor="firstName">First Name</Label>
						        <Input type="firstName" name="firstName" onChange={this.onDialogInputChange} required />
			        </FormGroup>
			        <FormGroup className="col-md-6">
						        <Label htmlFor="lastName">Last Name</Label>
						        <Input type="lastName" name="lastName" onChange={this.onDialogInputChange} required />
			        </FormGroup>
                </div>
                <div className="row">
                    <FormGroup className="col-md-6">
					    <Label htmlFor="">Address1</Label>
					    <Input type="text" name="mailingAddress1" onChange={this.onDialogInputChange} required />
				    </FormGroup>
				    <FormGroup className="col-md-6">
					    <Label htmlFor="">Address2</Label>
					    <Input type="text" name="mailingAddress2" onChange={this.onDialogInputChange} />
                    </FormGroup>
                </div>
                <div className="row">
				    <FormGroup className="col-md-6">
							    <Label htmlFor="city">City</Label>
							    <Input type="city" name="mailingCity" onChange={this.onDialogInputChange} required />
				    </FormGroup>
				    <FormGroup className="col-md-3">
                        <Label htmlFor="state">State</Label>
						    <DropDownList data={this.props.common.states}
							    id="State"
							    name="state"
							    textField="name"
							    dataItemKey="id"
							    onChange={this.handleState}
							    value={this.state.stateObject}
									required
						    />
				    </FormGroup>
					<FormGroup className="col-md-3">
						<Label htmlFor="county">County</Label>
						<DropDownList data={this.props.district.counties}
							    id="County"
							    name="county"
							    textField="countyName"
							    dataItemKey="countyId"
							    onChange={this.handleCounty}
							    value={this.state.County}
						    />
					</FormGroup>
				    <FormGroup className="col-md-6">
							    <Label htmlFor="zip">Zip</Label>
							    <Input type="zip" name="mailingZip" onChange={this.onDialogInputChange} required />
                    </FormGroup>
					<FormGroup className="col-md-6">
							    <Label htmlFor="phone">Phone</Label>
							    <Input type="phone" name="phone" onChange={this.onDialogInputChange}/>
                    </FormGroup>
					
					{auth.isInRole('INTERNAL') && !this.props.isOwner? 
					<FormGroup className="membershipOwner">
                     <input
                            type="checkbox"
                            id="IsMembershipOwner"
                            name="IsMembershipOwner"
                            checked={this.state.isMembershipOwner}
                            onChange={this.handleCheckboxChange}
                        />
                        <label htmlFor="IsMembershipOwner">
                            <span className={ this.state.isMembershipOwner ? " far fa-check-square" : "far fa-square"}></span>
                            <span className="custom-control-text">IsMebership Owner</span>
                        </label>
                     </FormGroup>
					 :""}
                </div>
								<div className="modal-footer modal-footer-inner">
                    <button type="submit" className="btnPrimary admin-k-button" onClick={this.props.checkForm}>
                        <i className="fas fa-paper-plane"></i>
                        <span>Send Invite</span>
                    </button>
					<button className="btn btn-cancel btnSecondary admin-k-button authorizedUsrCancelBtn" onClick={this.handleCancel}>
                        <i className="fas fa-times"></i>
                        <span>CANCEL</span>
                    </button>
                </div>
			</form>
		);
	}
}
function mapStateToProps(state) {
    return {
		common: state.common,
		district: state.district,
		accountDetails: state.accountDetails
    }
}
export default withRouter(connect(mapStateToProps, { fetchStates, getCounties })(ManualUserForm));
